import React from "react";
import BookingConfirmation from "pagesV2/pro/Embedded/BookingConfirmation";

const ClientGuestBookingConfirmation = () => {
    return (
        <BookingConfirmation mode={"clientBooking"} />
    )
}

export default ClientGuestBookingConfirmation